import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useFeatureContext } from '../context/FeatureContext';
import { heeftBeheerrecht } from '../utils/beheerrechten';

/**
 * RoleRoute: alleen voor docenten met een van de opgegeven rollen.
 * Gebruik binnen ProtectedRoute (die regelt ingelogd-zijn).
 *
 * De "bekijk als school"-preview van een TestWisely-admin kan de rol
 * nabootsen (previewRole), net als in de Sidebar. Zolang het docentprofiel
 * nog laadt tonen we een spinner in plaats van weg te sturen: currentUser is
 * er eerder dan docentProfile en anders flikkert een beheerder even naar het
 * dashboard.
 *
 * beheerrecht (26-10-2026, migratie 117): een beheerder moet ook dit recht hebben, bijvoorbeeld
 * coaching_inzien voor Coaching · beheer. Een admin heeft alles; in de preview ook.
 */
function RoleRoute({ roles, beheerrecht = null, children, fallback = '/dashboard-new' }) {
  const { docentProfile, loading } = useAuth();
  const { previewRole } = useFeatureContext();

  if (loading || !docentProfile) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ width: '36px', height: '36px', border: '3px solid rgba(13,148,136,0.2)', borderTopColor: '#0D9488', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  const effectiveRol = previewRole ?? docentProfile.rol;
  if (!roles.includes(effectiveRol)) {
    return <Navigate to={fallback} replace />;
  }
  if (beheerrecht && docentProfile.rol !== 'admin' && !heeftBeheerrecht({ ...docentProfile, rol: effectiveRol }, beheerrecht)) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}

export default RoleRoute;
